import {createStyles} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';

import * as colors from 'assets/theme/colors';

export const useAppBarStyles = makeStyles(() =>
    createStyles({
        topBar: {
            top: 0,
            bottom: 'auto',
            width: '75%',
            background: `${colors.neutrals.A10} !important`,
        },
        appBar: {
            top: 'auto',
            bottom: 0,
            width: '75%',
            background: `${colors.neutrals.A10} !important`,
        },
        snackBarSuccess: {
            background: `${colors.feedback.S00} !important`,
        },
        snackBarError: {
            background: `${colors.feedback.E00} !important`,
        },
    })
);
